<template>
  <div class="confirmation-info" v-if="resultsAddons.length > 0 && (visibleAddons.length > 0 || promotionAddons.length > 0)">
    <h3>{{ $t('payment.addon.peace_of_mind') }}</h3>
    <div v-if="promotionAddons.length > 0" :class="{'promo-addons' : visibleAddons.length > 0}">
      <div class="addon-promotion">
        <div class="addon-promotion__extras">
          {{ $t('payment.addon.extras') }}
        </div>
        <div class="addon-promotion__addons">
          <div class="addon-promotion__item" v-for="addon in promotionAddons" :key="addon.addon_id">
            <span class="addon-promotion__check"></span>
            {{ addon.addon_name_short }}
          </div>
        </div>
      </div>

      <div class="confirmation-holder" v-for="(addon, key) in promotionAddons" :key="key">
        <span class="help" v-if="addon.addon_type != 'default' && addon.addon_promo_desc.length > 0 && !(category !== 'airportparking' && addon.addon_dir === 'insurance')">
          <i class="icon-help" v-tooltip="{ 
            content: `
              <strong>${addon.addon_name}</strong>
              <p>${ addon.addon_desc }</p>
            `}">
          </i> {{ addon.addon_promo_desc }}
        </span>
      </div>
    </div>

    <div class="confirmation-holder" v-for="(addon, key) in visibleAddons" :key="key">
      <div class="wrap" v-if="addon.addon_type != 'default' && !(category !== 'airportparking' && addon.addon_dir === 'insurance')"> 
        <input type="checkbox" 
          :id="addon.addon_id" 
          :checked="cartAddons.some(e => e.product.product_id == addon.product_id)"
          disabled="disabled"
        />
        <label 
          @click="toggleAddon($event, addon)" 
          :for="addon.addon_id" 
          class="sign-checkbox"
          :class="{'addon-default' : addon.addon_type === 'default'}"
          :disabled="addon.addon_type === 'default'"
        >
          {{ $t('payment.addon.add') }} 
          {{ addon.addon_name }} 
          {{ $t('payment.addon.for') }}  
          {{ currency }}{{ addon.addon_price }}
        </label>
      </div>
      <span class="help" v-if="addon.addon_type != 'default' && addon.addon_info.length > 0 && !(category !== 'airportparking' && addon.addon_dir === 'insurance')">
        <i class="icon-help" v-tooltip="{ 
          content: `
            <strong>${addon.addon_name}:</strong>
            <p>${ addon.addon_desc }</p>
          `}">
        </i> {{ addon.addon_info }}
      </span>
    </div>
  </div>
</template>

<script>
import { get, call, sync } from "vuex-pathify";
import * as _ from "lodash";
import mixins from "@/mixins";

export default {
  name: "addons-details",
  mixins: [mixins.load, mixins.globals],
  computed: {
    resultsAddons: get("results/products@addon"),
    cartAddons: sync("cart/products@addon"),
    cart: sync("cart/products"),
    category: get("quote/category"),
    visibleAddons() {
      if(this.resultsAddons.length < 1) return []
      let excluded = (this.cart[this.category].length > 0 ? (this.cart[this.category][0].product.exclude_addon_id || 0) : 0);
      
      return _.cloneDeep(this.resultsAddons).filter(a => {
        return  a.free !== "1" && a.addon_id !== excluded && (a.addon_type === "standard" || ( a.addon_type !== "default" && this.cartAddons.some( e => e.product.product_id == a.product_id )))
      })
    },
    promotionAddons() {
      if(this.resultsAddons.length < 1) return []
      let excluded = (this.cart[this.category].length > 0 ? (this.cart[this.category][0].product.exclude_addon_id || 0) : 0);
      
      return _.cloneDeep(this.resultsAddons).filter(a => {
        return a.free === "1" && a.addon_id !== excluded && (a.addon_type === "standard" || ( a.addon_type !== "default" && this.cartAddons.some( e => e.product.product_id == a.product_id )))
      })
    }
  },
  methods: {
    addCart: call("cart/addToCart"),
    removeCart: call("cart/removeCart"),
    toggleAddon(e, addon) {
      if(addon.addon_type === "default") return
      this.fakeLoad();
      let product = { category: 'addon', ...addon };
      if(this.cartAddons.some(e => e.product.product_id == addon.product_id)) return this.removeCart(product);
      this.addCart(product);
    }
  }
};
</script>